import script from "./ContactService.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactService.vue?vue&type=script&setup=true&lang=js"

import "./ContactService.vue?vue&type=style&index=0&id=54271050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54271050"]])

export default __exports__